import { millisToMinutesAndSeconds } from 'modules/overlay-v2/domain/utils/convert-time';
import { selectPeriodLabel } from 'modules/overlay-v2/store/game-info/selectors';
import { useSelector } from 'react-redux';
import useGameInfo from './use-game-info';
import useTime from './use-time';
import useTimer from './use-timer';

function useDataForCommon() {
  const { timer } = useTimer();
  const { period } = useTime();
  const periodLabel = useSelector(selectPeriodLabel);
  const gameInfo = useGameInfo();

  return {
    ...gameInfo,
    periodLabel,
    foulsIndicator: {
      first: gameInfo.fouls?.first ?? 0,
      second: gameInfo.fouls?.second ?? 0,
    },
    timer: millisToMinutesAndSeconds(timer),
    period,
    championshipName: gameInfo.championship?.name,
    city: gameInfo.match?.address.city,
    organizerLogo: gameInfo.organizer?.logo,
    teams: {
      first: {
        ...gameInfo?.teams?.first,
        lastGamesResults: gameInfo.teams?.first.lastGamesResults.map((x) => x.result),
      },
      second: {
        ...gameInfo?.teams?.second,
        lastGamesResults: gameInfo.teams?.second.lastGamesResults.map((x) => x.result),
      },
    },
  };
}

export default useDataForCommon;
